export default __webpack_public_path__ + "static/media/md-globe.fcdd1a30.svg";